import styles from './style.module.scss';
const paddingSizes = {
  none: 'none',
  xSmall: 'x-small',
  small: 'small',
  medium: 'medium',
  large: 'large'
};
const getSinglePaddingClass = (side, size) => styles[`padding-${side}-${paddingSizes[size] ?? 'medium'}`];
export const getPaddingBySize = size => {
  if (typeof size === 'string') {
    // Keep the undocumented legacy alias for older consumers.
    const paddingSize = size === 'extraSmall' ? 'x-small' : paddingSizes[size];
    return styles[`padding-${paddingSize}`];
  }
  if (size) {
    return [getSinglePaddingClass('block-start', size.blockStart), getSinglePaddingClass('block-end', size.blockEnd), getSinglePaddingClass('inline-start', size.inlineStart), getSinglePaddingClass('inline-end', size.inlineEnd)];
  }
  return styles['padding-medium'];
};